import { Trans } from 'react-i18next';
import { TermsNoticeContainer } from './Register.styles';

const RegisterTermsNotice = () => (
  <TermsNoticeContainer data-testid="terms-notice">
    <Trans
      i18nKey="pageRegister.termsNotice"
      components={{
        termsLink: (
          <a
            href="https://www.hostfully.com/terms-of-service/" //TODO
            data-testid="terms-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Terms and Conditions"
          />
        ),
      }}
    />
  </TermsNoticeContainer>
);

export default RegisterTermsNotice;
